import React from "react";
import {
  FormControl,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@mui/styles";
import {
  PREFERENCE_PRIORITY_MESSAGE,
  ENTER_PREFERENCE_FOR_HOLIDAYS,
  THANKS_GIVING_DAY_PERMANENT_BID,
  CHRISTMAS_DAY_PERMANENT_BID,
} from "../util/messageConstants";
import StarsSelectInput from "../components/fundamentals/StarsSelectInput";
import { PERMANENT_BID_HOLIDAY_CHOICES, DAYS_OFF, SHIFT } from "../util/constants";
import { validateChoices } from "../util/permanentBidInputValidation";
import { copyJsonObject, sortOnCaseSensitiveTexts } from "../util/commonUtils";

const useStyles = makeStyles((theme) => ({
  inputSelect: {
    textAlign: "left",
    marginRight: "10px",
    background: "white",
  },
  preferenceWidth: {
    width: "100%",
  },
  holidayPreference: {
    width: "100%",
    textAlign: "left",
  },
  selectMargin: {
    marginTop: "16px",
  },
  holidayFont: {
    fontSize: "14px",
  },
  prefTitle: {
    color: theme.palette.primary.swaBlue,
    fontSize: "14px",
  },
  prefMargin: {
    marginTop: 0,
    marginBottom: 0,
  },
  messageStyle: {
    textAlign: "left",
    paddingLeft: "16px",
    paddingTop: "8px",
    backgroundColor: theme.palette.secondary.swaLightestBlue,
  },
  accordingStyle: {
    backgroundColor: theme.palette.secondary.swaLightestBlue,
  },
  bidPaddingTop: {
    paddingTop: "16px",
  },
}));

const HolidayPreference = (props) => {
  const classes = useStyles();
  const {
    dayShiftPreference,
    handleDayShiftPreference,
    dayShiftPreferenceError,
    christmasChoices,
    setChristmasChoices,
    thanksgivingChoices,
    setThanksgivingChoices,
    thanksgivingChoiceErrors,
    setThanksgivingChoiceErrors,
    christmasChoiceErrors,
    setChristmasChoiceErrors,
    expanded,
    setExpanded,
    isReadOnly,
  } = props;

  const onChristmasChoiceChange = (fieldName, selectedChoice) => {
    const choices = copyJsonObject(christmasChoices);
    choices[fieldName] = selectedChoice;
    setChristmasChoices(choices);
    const errors = validateChoices(choices);
    setChristmasChoiceErrors(errors);
  };

  const onThanksgivingChoiceChange = (fieldName, selectedChoice) => {
    const choices = copyJsonObject(thanksgivingChoices);
    choices[fieldName] = selectedChoice;
    setThanksgivingChoices(choices);
    const errors = validateChoices(choices);
    setThanksgivingChoiceErrors(errors);
  };
  const handleExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <Divider />
      <Grid className={classes.prefMargin}>
        <Accordion className={classes.accordingStyle} expanded={expanded} onChange={() => handleExpanded()}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.prefTitle}>{ENTER_PREFERENCE_FOR_HOLIDAYS}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography className={classes.holidayFont}>
                  <b>{THANKS_GIVING_DAY_PERMANENT_BID}</b>
                </Typography>
                <Grid container className={classes.selectMargin}>
                  <Grid item xs={6} sm={6} md={3} data-testid="earliestAM">
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Earliest AM"
                        menuMessage="Select"
                        value={thanksgivingChoices["earliestAM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={thanksgivingChoiceErrors.earliestAM}
                        className={classes.inputSelect}
                        onChange={(e) => onThanksgivingChoiceChange("earliestAM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} data-testid="latestAM">
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Latest AM"
                        menuMessage="Select"
                        value={thanksgivingChoices["latestAM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={thanksgivingChoiceErrors.latestAM}
                        className={classes.inputSelect}
                        onChange={(e) => onThanksgivingChoiceChange("latestAM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    className={props.isDesktopView ? undefined : classes.bidPaddingTop}
                    data-testid="earliestPM"
                  >
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Earliest PM"
                        menuMessage="Select"
                        value={thanksgivingChoices["earliestPM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={thanksgivingChoiceErrors.earliestPM}
                        className={classes.inputSelect}
                        onChange={(e) => onThanksgivingChoiceChange("earliestPM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    className={props.isDesktopView ? undefined : classes.bidPaddingTop}
                    data-testid="latestPM"
                  >
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Latest PM"
                        menuMessage="Select"
                        value={thanksgivingChoices["latestPM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={thanksgivingChoiceErrors.latestPM}
                        className={classes.inputSelect}
                        onChange={(e) => onThanksgivingChoiceChange("latestPM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.holidayFont}>
                  <b>{CHRISTMAS_DAY_PERMANENT_BID}</b>
                </Typography>
                <Grid container className={classes.selectMargin}>
                  <Grid item xs={6} sm={6} md={3} data-testid="christmas-earliestAM">
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Earliest AM"
                        menuMessage="Select"
                        value={christmasChoices["earliestAM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={christmasChoiceErrors.earliestAM}
                        className={classes.inputSelect}
                        onChange={(e) => onChristmasChoiceChange("earliestAM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} data-testid="christmas-latestAM">
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Latest AM"
                        menuMessage="Select"
                        value={christmasChoices["latestAM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={christmasChoiceErrors.latestAM}
                        className={classes.inputSelect}
                        onChange={(e) => onChristmasChoiceChange("latestAM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    className={props.isDesktopView ? undefined : classes.bidPaddingTop}
                    data-testid="christmas-earliestPM"
                  >
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Earliest PM"
                        menuMessage="Select"
                        value={christmasChoices["earliestPM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={christmasChoiceErrors.earliestPM}
                        className={classes.inputSelect}
                        onChange={(e) => onChristmasChoiceChange("earliestPM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    className={props.isDesktopView ? undefined : classes.bidPaddingTop}
                    data-testid="christmas-latestPM"
                  >
                    <FormControl fullWidth>
                      <StarsSelectInput
                        label="Latest PM"
                        menuMessage="Select"
                        value={christmasChoices["latestPM"]}
                        allOptions={PERMANENT_BID_HOLIDAY_CHOICES}
                        sortComparator={sortOnCaseSensitiveTexts}
                        errors={christmasChoiceErrors.latestPM}
                        className={classes.inputSelect}
                        onChange={(e) => onChristmasChoiceChange("latestPM", e.target.value)}
                        disabled={isReadOnly}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid className={classes.messageStyle} data-testid="dayShift-preference">
        <FormControl error={dayShiftPreferenceError}>
          <FormLabel id="demo-row-radio-buttons-group-label" className={classes.prefTitle}>
            {PREFERENCE_PRIORITY_MESSAGE}
          </FormLabel>
          <RadioGroup row onChange={(e) => handleDayShiftPreference(e)} value={dayShiftPreference}>
            <FormControlLabel
              value={DAYS_OFF}
              control={<Radio />}
              label={<Typography className={classes.holidayFont}>{DAYS_OFF}</Typography>}
              disabled={isReadOnly}
            />
            <FormControlLabel
              value={SHIFT}
              control={<Radio />}
              label={<Typography className={classes.holidayFont}>{SHIFT}</Typography>}
              disabled={isReadOnly}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </>
  );
};

export default HolidayPreference;
